import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { hideLoader } from '../../Slice/LoaderSlice';
import { store } from '../../../Redux/Store';

const RoleGuard = ({ children, allowedRoles }) => {
  const { isLoggedIn, role } = useSelector((state) => state.auth);
  // Clean up any active loaders when component mounts
  useEffect(() => {
    // Clear all loaders when RoleGuard mounts to prevent stuck loaders
    const currentState = store.getState();
    const loaderState = currentState.loader;

    // Hide any active loaders
    Object.keys(loaderState).forEach((loaderKey) => {
      if (loaderState[loaderKey]) {
        store.dispatch(hideLoader(loaderKey));
      }
    });
  }, []);

  // If not logged in, redirect to appropriate login page based on allowed roles
  if (!isLoggedIn) {
    const loginPath = allowedRoles.includes('Superadmin') ? '/admin-login' : '/';
    return <Navigate to={loginPath} replace />;
  }

  // If user doesn't have the required role, redirect to unauthorized page
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // If user has the required role, render the protected content
  return children;
};

RoleGuard.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RoleGuard;
